// extracted by mini-css-extract-plugin
export default {"panel":"accordion_panel__xaEMJ","open":"accordion_open__e1gP1","title":"accordion_title__lnJML","icon":"accordion_icon__yc+xV","content":"accordion_content__xT1-s"};